import React from "react";
import {createRoot} from "react-dom/client";
import SwishFormBlockApp from "./SwishFormBlockApp";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
const container = document.getElementById('js-swish-form-block')!;
const root = createRoot(container);
const queryClient = new QueryClient();
root.render(
    <QueryClientProvider client={queryClient}>
        <SwishFormBlockApp />
    </QueryClientProvider>
);